module.exports = __webpack_public_path__ + "static/img/teBuTop.f389af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuTop.png
// module id = Yob2
// module chunks = 2